import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    instantUnstake: 'Instant unstake',
    standardUnstake: 'Standard unstake',
    upTo: 'Up to: {value} {token}',
    fee: '{value}% fee',
    noFee: 'no fee',
    period: '{period} {period, plural, =1 {day} other {days}}',
  },
};
